import React from 'react';

import RootLayout from 'common/layout/root-layout';
import { AccountPlatformFeatureProvider } from 'components/account-platform-features/context';
import { useUser } from 'contexts/user';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import ChargingPolicies from '../screens/PoliciesAndGroups/ChargingPolicies/ChargingPolicies';
import CustomerGroups from '../screens/PoliciesAndGroups/CustomerGroups/CustomerGroups';
import ChargingGroups from '../screens/PoliciesAndGroups/ChargingGroups/ChargingGroups';
import { ChargingPolicyForm } from '../screens/PoliciesAndGroups/ChargingPolicies/form/ChargingPolicyForm';
import GroupsAndPolicies from '../screens/PoliciesAndGroups/PoliciesAndGroups';
import { CpoBreadcrumbs } from '../screens/PoliciesAndGroups/CpoBreadcrumbs';
import {
  CHARGING_STATIONS_POLICIES_AND_GROUPS_CHARGING_GROUPS_ROUTE,
  CHARGING_STATIONS_POLICIES_AND_GROUPS_CHARGING_POLICIES_ROUTE,
  CHARGING_STATIONS_POLICIES_AND_GROUPS_CUSTOMER_GROUPS_ROUTE,
  CHARGING_STATIONS_POLICIES_AND_GROUPS_EDIT_CHARGING_POLICY_ROUTE,
  CHARGING_STATIONS_POLICIES_AND_GROUPS_NEW_CHARGING_POLICY_ROUTE,
} from './routes';

export function CpoRoutes() {
  const { user } = useUser();

  return (
    <RootLayout>
      <AccountPlatformFeatureProvider accountId={user?.accountId}>
        <CpoBreadcrumbs />

        <Switch>
          <Route
            path={
              CHARGING_STATIONS_POLICIES_AND_GROUPS_EDIT_CHARGING_POLICY_ROUTE
            }
            component={(props: RouteComponentProps) => (
              <GroupsAndPolicies>
                <ChargingPolicyForm mode="edit" {...props} />
              </GroupsAndPolicies>
            )}
          />
          <Route
            path={
              CHARGING_STATIONS_POLICIES_AND_GROUPS_NEW_CHARGING_POLICY_ROUTE
            }
            component={(props: RouteComponentProps) => (
              <GroupsAndPolicies>
                <ChargingPolicyForm mode="create" {...props} />
              </GroupsAndPolicies>
            )}
          />
          <Route
            path={CHARGING_STATIONS_POLICIES_AND_GROUPS_CHARGING_POLICIES_ROUTE}
            component={() => (
              <GroupsAndPolicies>
                <ChargingPolicies />
              </GroupsAndPolicies>
            )}
          />
          <Route
            exact
            path={CHARGING_STATIONS_POLICIES_AND_GROUPS_CUSTOMER_GROUPS_ROUTE}
            component={() => (
              <GroupsAndPolicies>
                <CustomerGroups />
              </GroupsAndPolicies>
            )}
          />
          <Route
            exact
            path={CHARGING_STATIONS_POLICIES_AND_GROUPS_CHARGING_GROUPS_ROUTE}
            component={() => (
              <GroupsAndPolicies>
                <ChargingGroups />
              </GroupsAndPolicies>
            )}
          />
        </Switch>
      </AccountPlatformFeatureProvider>
    </RootLayout>
  );
}
